export const defaultNumberFormatter = new Intl.NumberFormat("en-US", {
  // maximumFractionDigits: 2,
  maximumFractionDigits: 1,
});
